import { render, staticRenderFns } from "./memberDetailBanner.vue?vue&type=template&id=5022ad84&scoped=true&"
import script from "./memberDetailBanner.vue?vue&type=script&lang=js&"
export * from "./memberDetailBanner.vue?vue&type=script&lang=js&"
import style0 from "./memberDetailBanner.vue?vue&type=style&index=0&id=5022ad84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5022ad84",
  null
  
)

export default component.exports